import CmClient from './CmClient';

export default class HolderCmClient extends CmClient {
    constructor(id, options) {
        super(id, options, 'HolderCmClient');
    }
}
